module.exports = __webpack_public_path__ + "img/badge-chat-with-the-planet.f0c0d419.png";